import React from 'react'
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import {
	publicRoutes,
	privateRoutes,
	adminPrivateRoutes,
	cashierRoutes,
	workshopRoutes,
} from './routes'

import { checkPermission } from 'helpers/helpers';
import Layout from 'containers/layout/owner/Layout';
import LayoutCashier from 'containers/layout/cashier/Layout';
import LayoutWorkshop from 'containers/layout/workshop/Layout';
import LayoutAdmin from 'containers/layout/admin/Layout';
import NoAuthLayout from 'containers/layout/NoAuthLayout';

function createPublicRoutes() {
	return publicRoutes.map((item, key) => {
		return (
			<Route key={key} path={item.path} element={item.component} />
		);
	});
}

function createCashierRoutes() {
	const role = localStorage.getItem("role");

	// Ba'zi yo'llar HAM cashierRoutes da, HAM privateRoutes da bor
	// (hozir: /production-board va /cashbox/pending-orders — ikkisi ham owner menyusida bor).
	// cashierRoutes birinchi ro'yxatdan o'tadi, shuning uchun aks holda owner/direktor ham
	// KASSIR layoutini olardi: o'z sidebar'i yo'qolib, kassirning «orqaga» tugmasi paydo bo'lardi.
	// Owner/direktor uchun bunday takrorlangan yo'llarni o'tkazib yuboramiz — pastdagi
	// privateRoutes (owner Layout) ularni o'z sidebar'i bilan ko'rsatadi.
	const isOwnerSide = role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR';
	const ownerPaths = isOwnerSide ? new Set(privateRoutes.map(r => r.path)) : new Set();

	return cashierRoutes
		.filter((item) => !ownerPaths.has(item.path))
		.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
}

function createWorkshopRoutesRoutes() {
	const role = localStorage.getItem("role");

	// Ba'zi yo'llar HAM workshopRoutes da, HAM privateRoutes da bor
	// (hozir: /employees — u rahbarga ham, egasiga ham kerak).
	// workshopRoutes privateRoutes'dan OLDIN ro'yxatdan o'tadi, shuning uchun aks holda
	// ega/direktor ham SEX layoutini olardi: yon menyusi yo'qolib, ishlab chiqarish
	// «orqaga» tugmasi paydo bo'lardi. Kassir tomonida aynan shu tuzoq allaqachon
	// tuzatilgan (createCashierRoutes) — bu yerda ham xuddi shunday qilamiz.
	const isOwnerSide = role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR';
	const ownerPaths = isOwnerSide ? new Set(privateRoutes.map(r => r.path)) : new Set();

	return workshopRoutes
		.filter((item) => !ownerPaths.has(item.path))
		.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
}

function createPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR') {
		/* ⚠️ TARIF FILTRI (2026-08-13). Ilgari ruxsat umuman tekshirilmasdi:
		   Start foydalanuvchisi menyuda «Аналитика» ni ko'rmasa ham, URL ni
		   qo'lda yozib sahifani TO'LIQ ocha olardi — sarlavha, filtrlar,
		   nol bilan to'lgan kartalar va qizil 403 toast.
		   Ma'lumot chiqmasdi (backend to'g'ri yopilgan), lekin dastur buzuq
		   ko'rinardi. Endi marshrutning O'ZI yaratilmaydi va foydalanuvchi
		   `createRedirectRoutes()` orqali bosh sahifaga qaytadi.
		   `permission` maydoni yo'q marshrutlar avvalgidek ochiq qoladi. */
		return privateRoutes
			.filter(item => !item.permission || checkPermission(item.permission))
			.map((item, key) => {
				return (
					<Route key={key} element={<ProtectedRoute />}>
						<Route path={item.path} element={item.component} />
					</Route>
				);
			});
	}
}

function createAdminPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_ADMIN') {
		return adminPrivateRoutes.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedAdminRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
	}
}

function createRedirectRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_ADMIN') {
		return (
			<Route path="*" element={<Navigate to="/admin/users" replace />} />
		);
	}
	if (role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR') {
		return (
			<Route path="*" element={<Navigate to="/payment-types" replace />} />
		);
	}

	// ⚠️ Sex rollarida bu YO'Q edi — natijada ro'yxatda bo'lmagan har qanday yo'l
	// pastdagi umumiy `*` ga tushib, foydalanuvchini LOGIN sahifasiga tashlardi.
	// Aynan shunday bo'lgan: Davomat sozlamasidagi «Boshqarish» tugmasi
	// /hikvision-devices ga yuborardi, u marshrut ro'yxatida yo'q edi va rahbar
	// tizimdan chiqib ketgandek bo'lardi (user shikoyati 2026-08-01).
	// Endi noma'lum yo'l o'z bosh sahifasiga qaytaradi — sessiya saqlanadi.
	if (role === 'ROLE_PROD_MANAGER' || role === 'ROLE_WORKSHOP') {
		return (
			<Route path="*" element={<Navigate to="/workshop" replace />} />
		);
	}
	if (role === 'ROLE_WAREHOUSE') {
		/* Login.js dagi bilan bir xil bo'lishi SHART — aks holda foydalanuvchi
		   bir joyga kirib, keyin boshqasiga otilib ketadi.
		   Кенгаш Pro imkoniyati, omborchi esa hamma tarifda ishlashi kerak. */
		return (
			<Route path="*" element={<Navigate to="/warehouse" replace />} />
		);
	}
	// Kassir va kuryerda ham qoida bo'lmasa — mos keladigan marshrut topilmay,
	// OQ SAHIFA chiqardi. Har rolga o'z bosh sahifasi (Login.js dagi bilan bir xil).
	if (role === 'ROLE_CASHIER' || role === 'ROLE_COURIER') {
		return (
			<Route path="*" element={<Navigate to="/cashbox" replace />} />
		);
	}
	// Rol noma'lum bo'lsa (eski saqlangan holat) — login sahifasi
	return (
		<Route path="*" element={<Navigate to="/auth/login" replace />} />
	);
}

function ProtectedRoute() {
	const login = localStorage.getItem("login");
	var isAuthenticated = false;
	if (login) {
		isAuthenticated = true
	} else {
		isAuthenticated = false
	}

	if (!isAuthenticated) {
		localStorage.removeItem('login')
		localStorage.removeItem('role')
		localStorage.removeItem('token')
		return <Navigate to="/auth/login" />;
	}

	return <Outlet />;
};

function ProtectedAdminRoute() {
	const login = localStorage.getItem("login");
	const role = localStorage.getItem("role");

	var isAuthenticated = false;
	if (login === 'admin' && role === 'ROLE_ADMIN') {
		isAuthenticated = true
	} else {
		isAuthenticated = false
	}

	if (!isAuthenticated) {
		localStorage.removeItem('login')
		localStorage.removeItem('role')
		localStorage.removeItem('token')
		return <Navigate to="/auth/login" />;
	}

	return <Outlet />;
};

const Index = () => {
	return (
		<Routes>
			<Route element={<NoAuthLayout />}>
				{createPublicRoutes()}
			</Route>

			{/* ⚠️ Bu «hammasi» qoidasi endi FAQAT kirmagan foydalanuvchiga.
			    Ilgari u har doim turardi va rol bo'yicha qaytarish qoidalaridan
			    OLDIN kelardi — natijada tizimga kirgan odam mavjud bo'lmagan yo'lga
			    tushsa, LOGIN sahifasiga otib ketardi (chiqib ketgandek).
			    Kirgan foydalanuvchini pastdagi createRedirectRoutes() o'z bosh
			    sahifasiga qaytaradi. */}
			{!localStorage.getItem('login') &&
				<Route element={<NoAuthLayout />}>
					<Route path="*" element={<Navigate to="/auth/login" replace />} />
				</Route>}

			<Route element={<LayoutCashier />}>
				{createCashierRoutes()}
			</Route>

			<Route element={<LayoutWorkshop />}>
				{createWorkshopRoutesRoutes()}
			</Route>

			<Route element={<Layout />}>
				{createPrivateRoutes()}
			</Route>

			<Route element={<Layout />}>
				{createRedirectRoutes()}
			</Route>

			<Route path="/admin" element={<LayoutAdmin />}>
				<Route path="/admin" element={<Navigate to="/admin/users" replace />} />
				{createAdminPrivateRoutes()}
			</Route>
		</Routes>
	)
}

export default Index;